import styled, { css } from 'styled-components';

import Input, { Sizes } from '../../../Input';

import MeasuringUnitInput from './components/MeasuringUnitInput';

const spacingBySize = css<{ size?: Sizes }>`
  &:not(:last-child) {
    ${({ size }) => {
      switch (size) {
        case Sizes.small:
          return css`
            margin-bottom: 14px;
          `;
        case Sizes.medium:
          return css`
            margin-bottom: 24px;
          `;
        default:
          return css`
            margin-bottom: 24px;
          `;
      }
    }}
  }
`;

export const StyledInput = styled(Input)`
  ${spacingBySize}
`;

export const StyledMeasuringUnitInput = styled(MeasuringUnitInput)`
  ${spacingBySize}
`;
